import AuthService from '../services/auth.service';

let user = null;
try {
  user = JSON.parse(localStorage.getItem('user'));
} catch (e) {
  console.error('Could not parse user from localStorage', e);
}

const initialState = user
  ? { loggedIn: true, user }
  : { loggedIn: false, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    isLoggedIn: state => state.loggedIn,
    currentUser: state => state.user,
  },
  actions: {
    async login({ commit }, userCredentials) {
      try {
        const user = await AuthService.login(userCredentials);
        commit('loginSuccess', user);
        return Promise.resolve(user);
      } catch (error) {
        commit('authError');
        return Promise.reject(error);
      }
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.loggedIn = true;
      state.user = user;
    },
    authError(state) {
      state.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.loggedIn = false;
      state.user = null;
    },
    updateUserSuccess(state, updatedUserInfo) {
      state.user = { ...state.user, ...updatedUserInfo };

      localStorage.setItem('user', JSON.stringify(state.user));
    }
  }
};
